/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveAktsFromFolderRequest
 */
export interface RemoveAktsFromFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveAktsFromFolderRequest
     */
    aktids?: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveAktsFromFolderRequest
     */
    folderid?: number;
}

export function RemoveAktsFromFolderRequestFromJSON(json: any): RemoveAktsFromFolderRequest {
    return RemoveAktsFromFolderRequestFromJSONTyped(json, false);
}

export function RemoveAktsFromFolderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveAktsFromFolderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktids': !exists(json, 'aktids') ? undefined : json['aktids'],
        'folderid': !exists(json, 'folderid') ? undefined : json['folderid'],
    };
}

export function RemoveAktsFromFolderRequestToJSON(value?: RemoveAktsFromFolderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktids': value.aktids,
        'folderid': value.folderid,
    };
}


